import React from 'react'
import { render } from 'react-dom'
import { Reacteroids } from './Reacteroids'
/* eslint-disable */
import style from './style.css'
/* eslint-enable */

render(<Reacteroids />, document.getElementById('root'))
